import { FileQuestionIcon } from 'lucide-react';
import type { JSX } from 'react';
import { redirect, useNavigate, useRouteContext } from '@tanstack/react-router';

import { Button } from '@/components/atoms/button';
import { PageDefaultLayout } from '@/components/layout/page-default';
import { StatusPage } from '@/components/layout/status-page';

export function NotFoundPage(): JSX.Element {
  const navigate = useNavigate();
  const { auth } = useRouteContext({ from: '__root__' });

  if (!auth.isAuthenticated) {
    throw redirect({ to: '/login' });
  }

  return (
    <PageDefaultLayout>
      <StatusPage
        variant="in-main"
        title="Page not found"
        description="The page you are looking for does not exist or may have been moved."
        icon={<FileQuestionIcon size={48} strokeWidth={1.5} />}
        actions={
          <Button
            variant="default"
            type="button"
            onClick={() => navigate({ to: '/documents' })}
          >
            Go to home
          </Button>
        }
      />
    </PageDefaultLayout>
  );
}
